import { Stack } from "@mui/material";
import { Panel } from "@poseidon/ui/components";
import config from "@poseidon/utils/config";
import { useEffect, useState } from "react";
import { PreviouslyUploadedFiles } from "../../../Files/PreviouslyUploadedFiles";

export function AgreementSailorFiles({ files }) {
  const [agreementSailorFiles, setAgreementSailorFiles] = useState();

  useEffect(() => {
    const reduced = files?.reduce((prev, curr) => {
      const { fileGroup } = curr;
      if (fileGroup in prev) {
        return {
          ...prev,
          [fileGroup]: [...prev[fileGroup], curr],
        };
      }
      return {
        ...prev,
        [fileGroup]: [curr],
      };
    }, {});

    if (!reduced) {
      return;
    }

    setAgreementSailorFiles(Object.entries(reduced));
  }, [setAgreementSailorFiles, files]);

  return (
    <Stack spacing={5}>
      {agreementSailorFiles?.map(([fileGroup, files]) => {
        const resolver = config.getFileResolver(fileGroup);
        return (
          <Panel
            key={fileGroup}
            collapsable
            startCollapsed={true}
            title={resolver.fileGroupLabel}
          >
            <PreviouslyUploadedFiles
              files={files}
              resolveMetadata={resolver}
              readonly={true}
              showMetadata={true}
            />
          </Panel>
        );
      })}
    </Stack>
  );
}
